import React from "react";
import { CHALLENGE } from "../../../../common/challengeConstants";

const VdoBadgeDetail = () => <p>
  {CHALLENGE.badges.VdoHeading}<br />
  {CHALLENGE.badges.VdoSubHeading}
</p>

export default VdoBadgeDetail;